import type { Flags } from "@/providers/LaunchDarklyProvider";
import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The one read of `new-home`. Nothing configured means the new home; the
 * flag exists to turn it off for the organizations that keep the legacy one.
 */
export function useNewHomeEnabled(): boolean {
  return useFlags<Flags>().newHome !== false;
}
